import { Dispatch } from 'redux'
import { signInStart, signInComplete, signInError, updateSignedAccountStart, updateSignedAccountError, updateSignedAccountComplete } from './actions'
import * as api from '~/service/api'
import { AccountForFront } from '@mutual-services/pj-panel-types'

export { signOut } from './actions'

export const signIn = ({ password, username }: api.SignInParams) => async (dispatch: Dispatch) => {
  dispatch(signInStart())
  let responseData

  try {
    responseData = await api.signIn({ username, password })
  } catch (err) {
    dispatch(signInError(err.response.data))
    return false
  }

  api.setAuthorizationToken(responseData.IdToken)
  api.setRefreshToken(responseData.RefreshToken)

  try {
    responseData = await api.authRequest({
      method: 'POST',
      url: `${api.PJ_PANEL_URL}/hrpc`,
      data: {
        method: 'getMe'
      }
    })
  } catch (err) {
    api.clearAuthorizationToken()
    api.clearRefreshToken()
    dispatch(signInError('COULD_NOT_COMPLETE'))
    return false
  }

  dispatch(signInComplete(responseData as AccountForFront))
  return true
}

export const bootAuthenticatedUser = () => async (dispatch: Dispatch) => {
  dispatch(signInStart())
  let account

  try {
    account = await api.authRequest({
      method: 'POST',
      url: `${api.PJ_PANEL_URL}/hrpc`,
      data: {
        method: 'getMe'
      }
    })
  } catch (err) {
    api.clearAuthorizationToken()
    api.clearRefreshToken()
    dispatch(signInError(err))
    return false
  }

  dispatch(signInComplete(account as AccountForFront))
  return true
}

export const updateSignedAccount = () => async (dispatch: Dispatch) => {
  dispatch(updateSignedAccountStart())
  let account

  try {
    account = await api.authRequest({
      method: 'POST',
      url: `${api.PJ_PANEL_URL}/hrpc`,
      data: {
        method: 'getMe'
      }
    })
  } catch (err) {
    dispatch(updateSignedAccountError(err))
    return false
  }

  dispatch(updateSignedAccountComplete(account as AccountForFront))
  return true
}
